import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import CustomerLogin from '../CustomerLogin';

// El mismo panel de login que usa HasCustomerRoute, pero en un diálogo: el
// comprador no pierde la pantalla en la que estaba. Cuando la sesión aparece
// se cierra y llama a onLoggedIn (p. ej. para completar "Agregar al carrito").
const CustomerLoginDialog = ({
    open,
    onClose,
    onLoggedIn,
    customer,
    title,
    subtitle,
}) => {
    const wasOpenAnonymous = useRef(false);

    useEffect(() => {
        if (open && !customer) {
            wasOpenAnonymous.current = true;
        }
        if (open && customer && wasOpenAnonymous.current) {
            wasOpenAnonymous.current = false;
            onLoggedIn && onLoggedIn(customer);
        }
    }, [open, customer, onLoggedIn]);

    return (
        <Dialog
            open={open && !customer}
            onClose={onClose}
            PaperProps={{
                sx: { backgroundColor: 'transparent', boxShadow: 'none' },
            }}
        >
            <DialogContent sx={{ p: 0, position: 'relative' }}>
                <IconButton
                    aria-label="Cerrar"
                    onClick={onClose}
                    sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
                >
                    <CloseIcon />
                </IconButton>
                <CustomerLogin title={title} subtitle={subtitle} />
            </DialogContent>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        customer: state.customer.customer,
    };
};

export default connect(mapStateToProps)(CustomerLoginDialog);
